import { Checkbox as AntdCheckbox } from "antd";
import React, { ReactNode } from "react";
import { CheckboxProps as AntdCheckboxProps } from "antd/es/checkbox";

export interface MyCheckboxProps extends AntdCheckboxProps {
  children?: ReactNode;
}

export interface CheckboxStaticMethods {
  Group: typeof AntdCheckbox.Group;
}

const CheckboxPolyfill: React.FC<MyCheckboxProps> & CheckboxStaticMethods = ({
  children,
  ...props
}) => {
  return <AntdCheckbox {...props}>{children}</AntdCheckbox>;
};

CheckboxPolyfill.Group = AntdCheckbox.Group;

export default CheckboxPolyfill;
